import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilService} from '../../service/util.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-industries',
  templateUrl: './industries.component.html',
  styleUrls: ['./industries.component.css']
})
export class IndustriesComponent implements OnInit {

  constructor(private http: HttpClient, private util: UtilService) { }
  industryList: Observable<string[]>;



  ngOnInit(): void {
    this.getClients();
  }

  getClients() {
    this.industryList = this.http.get<string[]>(this.util.getUrl('industries.json'));
  }
}
